/**
 * Simple in-memory cache utility with TTL support
 * @param {number} ttlMs - Time-to-live in milliseconds
 */
class CacheManager {
  constructor(ttlMs = 5 * 60 * 1000) { // Default 5 minutes
    this.ttlMs = ttlMs;
    this.cache = new Map();
  }

  /**
   * Get value from cache if not expired
   */
  get(key) {
    if (!this.cache.has(key)) {
      return null;
    }

    const { value, timestamp } = this.cache.get(key);
    const isExpired = Date.now() - timestamp > this.ttlMs;

    if (isExpired) {
      this.cache.delete(key);
      return null;
    }

    return value;
  }

  /**
   * Set value in cache with current timestamp
   */
  set(key, value) {
    this.cache.set(key, {
      value,
      timestamp: Date.now()
    });
  }

  /**
   * Clear specific key or entire cache
   */
  clear(key = null) {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }

  /**
   * Check if key exists and is not expired
   */
  has(key) {
    return this.get(key) !== null;
  }
}

// Create a singleton instance for jobs cache (5 minute TTL)
export const jobsCache = new CacheManager(5 * 60 * 1000);

export default CacheManager;
